export function setupInteractions(map, { onParcelClick, onDeselect }) {
  let hoveredId = null;

  // Pointer cursor on hover
  map.on('mouseenter', 'parcels-fill', () => {
    map.getCanvas().style.cursor = 'pointer';
  });

  map.on('mouseleave', 'parcels-fill', () => {
    map.getCanvas().style.cursor = '';
    if (hoveredId !== null) {
      map.setFeatureState({ source: 'parcels', id: hoveredId }, { hover: false });
      hoveredId = null;
    }
  });

  // Hover highlight
  map.on('mousemove', 'parcels-fill', (e) => {
    if (e.features.length > 0) {
      const feature = e.features[0];
      const newId = feature.id ?? feature.properties.id;

      if (hoveredId !== null && hoveredId !== newId) {
        map.setFeatureState({ source: 'parcels', id: hoveredId }, { hover: false });
      }

      hoveredId = newId;
      map.setFeatureState({ source: 'parcels', id: hoveredId }, { hover: true });
    }
  });

  // Click to select parcel
  map.on('click', 'parcels-fill', (e) => {
    if (e.features.length > 0) {
      const feature = e.features[0];
      const id = feature.properties.id || feature.id;
      selectParcel(map, id);
      onParcelClick(feature);
    }
  });

  // Click on empty space to deselect
  map.on('click', (e) => {
    const features = map.queryRenderedFeatures(e.point, { layers: ['parcels-fill'] });
    if (features.length === 0) {
      deselectParcel(map);
      onDeselect();
    }
  });
}

export function selectParcel(map, parcelId) {
  map.setFilter('selected-parcel', ['==', ['get', 'id'], parcelId]);
  map.setFilter('selected-parcel-fill', ['==', ['get', 'id'], parcelId]);
}

export function deselectParcel(map) {
  map.setFilter('selected-parcel', ['==', ['get', 'id'], '']);
  map.setFilter('selected-parcel-fill', ['==', ['get', 'id'], '']);
}
